import React, { useEffect } from "react";
import textures from "../img/minecraftTextures.png";
import particles from '../img/particles.png'
import { features } from "../features";
import Feature from "./ui/Feature"
import { useInView } from "react-intersection-observer";
function Features() {
const img = new Image
    img.src = {particles}


    useEffect(() => {
      const particlesSrc = document.getElementById('minecraftParticles') 
      document.addEventListener('mousemove' , function(position){
        const x = -position.clientX
        const Y = position.clientY
        particlesSrc.style.top = Y/50+"px"
        particlesSrc.style.right = x/50+"px"
      })
    }, [img])

  return (
    <section id="features">
      <img src={textures}  className="textures textures-top" alt="" />
      <img src={particles} id='minecraftParticles' className="particles" />
      <div className="container">
      <h3 className="section-title features-section-title">Features</h3>
        <div className="features-wrapper">
          {features.map((elem) => <Feature key={elem.title} elem={elem}/>)}
        </div>
      </div>
      <img src={textures} className="textures textures-bottom" alt="" />
      <img src={textures} className="textures textures-bottom2" alt="" />

    </section>
  );
}
export default Features